import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { NotificationType } from 'src/app/models/notification.message';
import { movementapprovalDto } from 'src/app/models/movementapprovalDto';
import { MovementDto } from 'src/app/models/MovementDto';
import { MovementPendingApprovalDto } from 'src/app/models/MovementPendingApprovalDto';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import { MovementJDDto } from 'src/app/models/requests/MovementJDDto';
import { MovementJDVM } from 'src/app/models/requests/MovementJDVM';
import { DocumentsService } from 'src/app/services/documents.service';
import { ExcelexportService } from 'src/app/services/excelexport.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { MovementService } from 'src/app/services/movement.service';
import { MovementapprovalService } from 'src/app/services/movementapproval.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { VendorsService } from 'src/app/services/vendors.service';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';

@Component({
  selector: 'app-view-movement',
  templateUrl: './view-movement.component.html',
  styleUrls: ['./view-movement.component.css']
})
export class ViewMovementComponent implements OnInit {
  currentUser: any;
  Requests: MovementDto[] = [];
  UpdateRequest: any;
  receivedfile: string = '';
  canCreateMovement: boolean = false;
  canViewDocument: boolean = false;
  
  isChangeOkLoading = false;
  isShowRejectionMessage = false;
  cancelComment:string="";
  isShowCancelRequest: boolean = false;
  isCloseModalVisible:boolean=false;
  closeModalTitle:string ="";
  filter: any
  isTerminationVisible: boolean = false;
  pdf:string="";
  isCancelVisible:boolean=false;
  MovementRequestApprovals: movementapprovalDto[] | undefined;
  MovementPendingRequestApprovals: MovementPendingApprovalDto[] | undefined;
  MovementJD: MovementJDDto[] | undefined;
  canPrint: boolean = false;
  ViewManpowerRequestVisible = false;
  isPendingpprovalModalVisible = false;
  constructor(private router: Router, public datepipe: DatePipe,  private movementService: MovementService, private notification: NotificationService,
    private vendorService: VendorsService, private movementApprovalService: MovementapprovalService,
    private tokenService: TokenService, private fb: FormBuilder, private documentService: DocumentsService) { }

  ngOnInit(): void {
    ;
    this.filter = history.state.data;
    this.loadRecords(this.filter);
    this.UserViews();
  }
  
  downloadExcel() {
    ;
    const exportData: Partial<object>[] = this.Requests.map(
      
      x => ({
        
        Reference: x.reference,
        Requester: x.createdBy,
        RequestDate: x.createdDate,
        Status: x.isActive ? 'Active' : 'Inactive',
        EmployeeName: x.employeeName,
        SapNumber: x.employeeSAPNumber,
        Band: x.employeeBand,
        Designation: x.employeeDesignation,
        //Function: x.function,
        Unit:x.employeeUnit,
        NPlus1:x.employeeNPlus1,
        Location:x.employeeCurrentLocation,
        LastPromotionDate: x.lastPromotionDate,
        DateAssumedCurrentRole: x.datAssumeCurrentRole,
        ProposedDesignation: x.proposedDesignation,
        ProposedNplus1:x.reasonForVacancy,
        ProposedFunction:x.proposedFunction,
        ProposedUnit: x.proposedUnit,
        EffectiveDate:x.effectiveDate,
        ProposedBand:x.proposedBand,
        ProposedCostCenter:x.proposedCostCenter,
        ProposedLocation:x.proposedLocation,
        DateVacancyOccured:x.dateVacancyOccured,
        ReasonForVacancy:x.reasonForVacancy,
        JustificationForMovement: x.justificationForVacancy,
        TypeOfMovement:x.typeOfMovement,
        SystemRequirementsForNewRole:x.systemRequirementForNewRole,
        LastYear:x.performanceLastYear,
        TwoYears:x.twoYearsPerformance,
        ThreeYears:x.threeYearsPerformance,
        LastTalentReviewComments:x.lastTalentReviewComment,
        SuccessionPlanReady:x.successionPlanReady,
        DevelopmentPlan:x.developmentPlan,
        IdentifiedGaps:x.identifiedGaps

      })
    );
    ExcelexportService.exportArrayToExcel(exportData, 'Movement Export')
  }


  async open(data: MovementDto) 
  {
    this.canViewDocument = false;
    ;
    this.ViewManpowerRequestVisible = true;
    this.UpdateRequest = data;

   
    if (data.status === "Approved") {  this.canPrint = true }
    
     let resApprovals = await this.movementApprovalService.getRequestApprovals(data.id).toPromise();
     this.MovementRequestApprovals = <movementapprovalDto[]>resApprovals.responseData;
 
    this.UpdateRequest = data;

    if (data.status === "Approved") {  this.canPrint = true }
    let getJDRequest = await this.movementService.GetJDForRequest(data.id).toPromise();
    this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
    if (this.MovementJD.length > 0) {  this.canViewDocument = true }
    // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }

  }

  
  async openapproval(data: MovementDto) 
  {
    ;
    
    //this.UpdateRequest = data;
    this.UpdateRequest = data;
    let resApprovals = await this.movementService.getPendingRequestApprovals(data.id).toPromise();
    this.MovementPendingRequestApprovals = <MovementPendingApprovalDto[]>resApprovals.responseData;

    this.isPendingpprovalModalVisible = true;
    // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }

  }

async handleSubmit() {
  ;
      
      var obj:any = {}
     obj.NextApprovalEmail = this.UpdateRequest.nextToApprove;
     obj.RequestId = this.UpdateRequest.id;
 
     let resRequests = await this.movementService.SendManualReminder(obj).toPromise();
     ;
     this.Requests = <MovementDto[]>resRequests.responseData;
     this.notification.sendMessage({
        message: resRequests.message,
        type: NotificationType.success
      });
      this.isPendingpprovalModalVisible = false;

   }
  async loadRecords(filter: any) {
    ;
    this.currentUser = this.tokenService.getInfo(); 
    let resRequests = await this.movementService.getMovement().toPromise();
    this.Requests = <MovementDto[]>resRequests.responseData;

      
    for (const request of resRequests.responseData) {
      ;
      if ((request.createdBy == this.currentUser.profile.email)) { this.isShowCancelRequest = true; }
      if (request.rejectionMessage == 'Yes') {
        this.isShowRejectionMessage = true
      }
    }
    try {
      this.Requests?.sort((n1, n2) => {
        if (n1.id > n2.id) {
          return -1;
        }

        return 0;
      });
    } catch (error) {

    }

  }

  async beginCancel(data: MovementDto) 
  {
    this.closeModalTitle="Cancel Contract ";
     this.isCloseModalVisible = true;
     this.isCancelVisible = true;
   this.UpdateRequest=data;
  }

  UserViews(): void {

    try {

      ;
      const userData: LoginResponseData = this.tokenService.getInfo();
      var UserPermission = userData.permission;

      const ContractPerm = UserPermission.find((obj) => {
        return obj.permissionName === "MovementRequest";
      });

      if (ContractPerm) {
        this.canCreateMovement = ContractPerm.canAdd === true ? true : false;
       
      }


    }
    catch (e: unknown) { }


  }

  cancelRequest(){

    ;
    this.isChangeOkLoading=true;
    if (this.cancelComment === '') 
    {
      this.notification.sendMessage({
        message: 'Comment is required to close request',
        type: NotificationType.error
      });
      this.isChangeOkLoading=false;
    }
    else {
      this.isChangeOkLoading = true;
      const data =
      {
        id: this.UpdateRequest.id,
        message: this.cancelComment,
 

      }

      this.movementService.CancelRequest(data).subscribe({
        next: (data => {
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
            this.loadRecords(this.filter)
            this.isTerminationVisible = false;
            this.close()
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

            this.isChangeOkLoading = false;
          }

        }),
        error: ((error: any) => {
          console.log(error.error);

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });

          this.isChangeOkLoading = false;
        })

      });}

  }
  
  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }

  print(requestReference:string, templateId:string) {
    this.documentService.DownloadPDF(templateId, `Movement Request - ${requestReference}`);
  }
  cancel(): void {
    return;
  }

  
  close(): void {
    this.ViewManpowerRequestVisible = false;
    this.canPrint = false;
    
  }

  async getJD(datas: MovementDto) {
   // this.ViewManPowerVisible = true;
;
    this.UpdateRequest = datas;
    let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
    ;
  
    this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
  var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
   const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
    const blob = new Blob([b] , {type: "application/octet-stream"});
    FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);
  }

  async showDocument(datas: MovementDto){
    // this.open();
    ;
    let getJDRequest = await this.movementService.GetJDForRequest(datas.id).toPromise();
       ;
     
       this.MovementJD = <MovementJDDto[]>getJDRequest.responseData;
     
        this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
        this.pdf = getJDRequest.responseData[0].documentContent
     
      //  this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
              
       // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
       const pdfWindow = window.open("")!;    
       pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
       pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
       encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
   
   
   }
  getStatusColor(status: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-danger';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

}
